import { isNil } from "lodash";
import { firstValueFrom, of } from "rxjs";

export class ObjectUtils {

    static resetObjectFromObject(oldObj: any, newObj: any) {
        this.deleteProperties(oldObj);
        Object.assign(oldObj, newObj);
    }

    static deleteProperties(obj: any) {
        for (const x in obj) {
            if (Object.hasOwn(obj, x)) {
                delete obj[x];
            }
        }
    }

    static deepCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj)) as T;
    }

    static hasValue(obj: any): boolean {
        return !isNil(obj);
    }

    static stringHasValue(str: string): boolean {
        return !isNil(str) && str !== "" && str !== "null" && str !== "undefined";
    }

    static isNullOrUndefined(...args: any[]): boolean {
        if (isNil(args)) {
            return true;
        }

        return args.some(x => isNil(x));
    }

    static toCamel(o: any): any {
        let newO: { [x: string]: any };
        let origKey: string;
        let newKey: string;
        let value;
        if (o instanceof Array) {
            return o.map((val) => {
                if (typeof val === "object") {
                    val = this.toCamel(val);
                }
                return val;
            });
        } else {
            newO = {};
            for (origKey in o) {
                if (Object.hasOwn(o, origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = o[origKey];
                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = this.toCamel(value);
                    }
                    newO[newKey] = value;
                }
            }
        }
        return newO;
    }

    static cloneArray(array: any[], deepCopy = false): any[] {
        let cloneArray = [];
        if (deepCopy) {
            array.forEach(p => cloneArray.push(Object.assign({}, p)));
        } else {
            cloneArray = cloneArray.concat(array);
        }

        return cloneArray;
    }

    static isString(object: any) {
        return (typeof object === "string" || object instanceof String);
    }

    static removeUndefinedProperties(object: any, removeNull: boolean): any {
        Object.keys(object).forEach(key => object[key] === undefined || (object[key] === null && removeNull) ? delete object[key] : {});
        return object;
    }

    static async copyToClipboard(str: string): Promise<void> {
        try {
            return await navigator.clipboard.writeText(str);
        } catch (err) {
            console.error(err);
            return firstValueFrom(of());
        }
    }

    static async pasteFromClipboard(): Promise<string> {
        try {
            return await navigator.clipboard.readText();
        } catch (err) {
            console.error(err);
            return firstValueFrom(of(""));
        }
    }
}
